import { navSections } from '@/mocks/gossip';

const anchors = ['#speed', '#speed', '#evidence', '#comments', '#circles'];

export default function Footer() {
  return (
    <footer className="bg-accent-950 text-accent-100">
      <div className="mx-auto max-w-[1240px] px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-accent-500 text-lg text-foreground-950">
                <i className="ri-chat-smile-fill" />
              </span>
              <span className="font-heading text-xl font-black tracking-tight text-background-50">
                91<span className="text-accent-300">吃瓜</span>
              </span>
            </a>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-accent-200/90">
              91吃瓜 专注把最新瓜与前场爆料按时间线整理上首页，聊天记录、相关截图与最新动态一并汇总，吃瓜跟进不掉队。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-900 px-3.5 py-1.5 text-xs font-bold text-accent-100">
                <i className="ri-radar-line text-accent-400" /> 前线爆料
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-900 px-3.5 py-1.5 text-xs font-bold text-accent-100">
                <i className="ri-flashlight-fill text-accent-400" /> 新瓜速递
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-900 px-3.5 py-1.5 text-xs font-bold text-accent-100">
                <i className="ri-refresh-line text-accent-400" /> 实时更新
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-black tracking-wider text-background-50">栏目速览</h4>
            <ul className="mt-4 space-y-2.5">
              {navSections.map((n, i) => (
                <li key={n.label}>
                  <a
                    href={anchors[i]}
                    className="inline-flex items-center gap-2 text-sm text-accent-200/90 transition hover:text-background-50"
                  >
                    <i className={`${n.icon} text-accent-400`} />
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-black tracking-wider text-background-50">值班小编</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-accent-200/90">
              <li className="flex items-center gap-2">
                <i className="ri-mail-send-line text-accent-400" /> 递料：tougao@91chigua.demo
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400" /> 速递时段：8:00 — 次日 2:00
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-accent-400" /> 前排客服在线，随叫随到
              </li>
            </ul>
            <a
              href="#commentBox"
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-5 py-2.5 text-sm font-bold text-foreground-950 transition hover:bg-accent-400"
            >
              去前排发言
              <i className="ri-arrow-right-up-line" />
            </a>
          </div>
        </div>

        <div className="mt-12 border-t border-accent-900 pt-6">
          <p className="text-xs leading-relaxed text-accent-300/80">
            91吃瓜 为纯静态演示页面，页面内人物、平台、聊天记录与截图均属虚构情境，仅用于社区氛围与版式展示，不指代任何真实组织或个人。按钮、表单与评论均未接入真实接口，输入内容不会被提交。
          </p>
        </div>

        <div className="mt-6 flex flex-col gap-2 border-t border-accent-900 pt-5 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-accent-300/80">
            © {new Date().getFullYear()} 91吃瓜 · 最新瓜、前线爆料、实时更新一网打尽
          </p>
          <p className="flex items-center gap-4 text-xs text-accent-300/80">
            <a href="#top" className="hover:text-background-50">关于</a>
            <a href="#top" className="hover:text-background-50">递料规则</a>
            <a href="#top" className="hover:text-background-50">版权说明</a>
            <button type="button" aria-label="回到顶部" className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-900 text-accent-200 transition hover:bg-accent-700">
              <i className="ri-arrow-up-line" />
            </button>
          </p>
        </div>
      </div>
    </footer>
  );
}